// Turkish label maps for enums used across the app

export const ROLE_LABELS = {
  admin: "Yönetici",
  sales: "Satış Personeli",
  order_manager: "Sipariş Sorumlusu",
};

export const JOB_STATUS_FLOW = [
  ["teklif_verildi", "Teklif Verildi"],
  ["is_alindi", "İş Alındı"],
  ["olcu_alindi", "Ölçü Alındı"],
  ["teknik_kontrol", "İmalat Ölçüsü Alınacak"],
  ["siparis_hazirlaniyor", "Sipariş Hazırlanıyor"],
  ["siparis_verildi", "Sipariş Verildi"],
  ["uretimde", "Üretimde"],
  ["urun_hazir", "Ürün Hazır"],
  ["sevkiyat_bekliyor", "Sevkiyat Bekliyor"],
  ["montaj_planlandi", "Montaj Planlandı"],
  ["montaj_basladi", "Montaj Başladı"],
  ["eksik_servis_bekliyor", "Eksik / Servis Bekliyor"],
  ["montaj_tamamlandi", "Montaj Tamamlandı"],
  ["musteri_onayi_alindi", "Müşteri Onayı Alındı"],
  ["finansal_kapanis", "Finansal Kapanış Yapıldı"],
  ["is_kapatildi", "İş Kapatıldı"],
];

export const JOB_STATUS_LABELS = Object.fromEntries(JOB_STATUS_FLOW);

export const ORDER_STATUS_FLOW = [
  ["taslak", "Taslak"],
  ["onay_bekliyor", "Onay Bekliyor"],
  ["siparis_verildi", "Sipariş Verildi"],
  ["tedarikci_onayladi", "Tedarikçi Onayladı"],
  ["uretimde", "Üretimde"],
  ["kismi_teslim", "Kısmi Teslim"],
  ["hazir", "Hazır"],
  ["sevk_edildi", "Sevk Edildi"],
  ["teslim_alindi", "Teslim Alındı"],
  ["gecikti", "Gecikti"],
  ["iptal_edildi", "İptal Edildi"],
];
export const ORDER_STATUS_LABELS = Object.fromEntries(ORDER_STATUS_FLOW);

export const PRIORITY_LABELS = {
  dusuk: "Düşük",
  normal: "Normal",
  yuksek: "Yüksek",
  acil: "Acil",
};

export const CUSTOMER_TYPE_LABELS = {
  individual: "Bireysel",
  corporate: "Kurumsal",
};


// Semantic status color groups → maps to design guideline classes.
export function jobStatusTone(status) {
  if (status === "is_kapatildi" || status === "finansal_kapanis") return "success";
  if (status === "eksik_servis_bekliyor") return "danger";
  if (
    status === "musteri_onayi_alindi" ||
    status === "montaj_tamamlandi" ||
    status === "urun_hazir"
  )
    return "info";
  if (status === "teklif_verildi" || status === "is_alindi") return "neutral";
  return "warning";
}

export function orderStatusTone(status) {
  if (status === "teslim_alindi") return "success";
  if (status === "iptal_edildi" || status === "gecikti") return "danger";
  if (status === "hazir" || status === "sevk_edildi") return "info";
  if (status === "taslak") return "neutral";
  return "warning";
}

export const TONE_CLASSES = {
  success: "bg-emerald-100 text-emerald-800 border border-emerald-200",
  warning: "bg-amber-100 text-amber-800 border border-amber-200",
  danger: "bg-rose-100 text-rose-800 border border-rose-200",
  info: "bg-[#EAF7FF] text-[#168DEB] border border-[#BDE3FF]",
  neutral: "bg-slate-100 text-slate-800 border border-slate-200",
};

export const PAYMENT_METHODS = {
    nakit: "Nakit",
    kredi_karti: "Kredi Kartı / Mail Order",
    havale: "Havale / EFT",
    cek: "Çek",
    diger: "Diğer"
};
